import { render, staticRenderFns } from "./FormLayoutHorizontalIcon.vue?vue&type=template&id=904ef2f6&"
import script from "./FormLayoutHorizontalIcon.vue?vue&type=script&lang=js&"
export * from "./FormLayoutHorizontalIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports